export const home_paths = ['/', '/@/todays', '/@/products', '/@/sellers'];
